module.exports = __webpack_public_path__ + "img/startConfiguration.142f672.webp";